import React, { useEffect, useState } from 'react';
import '../css/FilterBar.css';
import { Link } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';

function FilterBar({ onSearch, filters, activeFiltersCount }) {
  const [companyName, setCompanyName] = useState(filters.companyName || '');
  const [role, setRoleName] = useState(filters.role || '');
  const [location, setLocationName] = useState(filters.location || '');
  const { user } = useUser();

  useEffect(() => {
    setCompanyName(filters.companyName || '');
    setRoleName(filters.role || '');
    setLocationName(filters.location || '');
  }, [filters]);

  const handleSearch = (e) => {
    e.preventDefault();
    onSearch({ companyName, role, location});
  };

  const handleClear = () => {
    setCompanyName('');
    setRoleName('');
    setLocationName('');
    onSearch({ companyName: '', role: '', location: '' });
  };

  return (
  <div className="filter-bar-container">
    <div className="filter-bar-heading">
      <div>
        <span className="filter-bar-eyebrow">Interview feed</span>
        <h2>Search by company, role, or location.</h2>
      </div>
      <div className="filter-bar-actions">
        {activeFiltersCount > 0 && (
          <button type="button" className="filter-clear-btn" onClick={handleClear}>
            Clear {activeFiltersCount} filter{activeFiltersCount > 1 ? 's' : ''}
          </button>
        )}
        {user && (
          <Link to="/add-article" className="filter-add-btn">Add Interview</Link>
        )}
      </div>
    </div>
    <form className="filter-bar" onSubmit={handleSearch}>
      <input
        type="text"
        placeholder="Company"
        value={companyName}
        onChange={e => setCompanyName(e.target.value)}
        className="filter-input"
      />
      <input
        type="text"
        placeholder="Role"
        value={role}
        onChange={e => setRoleName(e.target.value)}
        className="filter-input"
      />
      <input
        type="text"
        placeholder="Location"
        value={location}
        onChange={e => setLocationName(e.target.value)}
        className="filter-input"
      />
      <button type="submit" className="filter-search-btn">Apply Filters</button>
    </form>
    </div>

  );
}

export default FilterBar;
